import React from "react";
import { useNavigate } from "react-router";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-bg_primary border-t border-border_sec rounded-10">
      <div className="container">
        <div className="py-8 lg:py-60 border-b border-border_sec">
          <div className="flex justify-between gap-10 max-tab:items-center max-tab:text-center max-tab:flex-col">
            <div className="logo">
              <a
                href={process.env.REACT_APP_HOME_PAGE}
                className="text-lan_primary font-bold tracking-[2%] text-28 tab:text-35"
              >
                GuideProAI
              </a>
            </div>
            <div>
              <h6 className="font-semibold text-black mb-6">Solutions</h6>
              <div className="grid gap-4">
                <a
                  href=""
                  className="text-base text-gray hover:text-black hover:font-semibold"
                >
                  Warehouse SOPs
                </a>
                <a
                  href=""
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Educational App
                </a>
                <a
                  href=""
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Mentor Assistance
                </a>
                <a
                  href=""
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  AI Knowledge Integration
                </a>
              </div>
            </div>
            <div>
              <h6 className="font-semibold text-black mb-6">Company</h6>
              <div className="grid gap-4">
                <div
                  onClick={() =>
                    navigate(`${process.env.REACT_APP_HOME_PAGE}use-cases`)
                  }
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Use Cases
                </div>
                <div
                  onClick={() =>
                    navigate(`${process.env.REACT_APP_HOME_PAGE}roadmap`)
                  }
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Roadmap
                </div>
                <div
                  onClick={() =>
                    navigate(`${process.env.REACT_APP_HOME_PAGE}contact`)
                  }
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Contact
                </div>
              </div>
            </div>
            <div>
              <h6 className="font-semibold text-black mb-6">Legal</h6>
              <div className="grid gap-4">
                <div
                  // href="/privacy-policy"
                  onClick={() =>
                    navigate(`${process.env.REACT_APP_HOME_PAGE}privacy-policy`)
                  }
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Privacy Policy
                </div>
                <div
                  onClick={() =>
                    navigate(
                      `${process.env.REACT_APP_HOME_PAGE}terms-of-service`
                    )
                  }
                  className="text-base text-gray hover:text-black hover:font-semibold duration-200 cursor-pointer"
                >
                  Terms of Service
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="py-5 lg:py-30">
          <p className="text-gray text-center">
            © {new Date().getFullYear()} GuideProAI. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
